import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap'

export class DriverStatusUpdate extends Component {
    static displayName = DriverStatusUpdate.name;

    constructor(props) {
        super(props);
        this.state = { statusDetails: "Ready", statusStateOK: true, driveridValue: "", eventTimestamp: "" };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange = (event) => {
        if (event != null) {
            event.preventDefault();
            if (event.target.id === 'driverid') {
                this.setState({ driveridValue: event.target.value })
            }
            else if (event.target.id === 'timestamp') {
                    const d = new Date(event.target.value);
                    const options = {
                        year: 'numeric', month: '2-digit', day: '2-digit',
                        hour: '2-digit', minute: '2-digit', second: '2-digit',
                        hour12: false,
                        timeZone: 'UTC'
                    };
                    const foramttedDateTime = new Intl.DateTimeFormat('en-US', options).format(d);
                    this.setState({ eventTimestamp: foramttedDateTime.replace(',', '') })
            }
        }
    };

    handleSubmit = (event) => {
        if (event != null) {
            event.preventDefault();
            this.sendOffDutyRequest(this.state.driveridValue, this.state.eventTimestamp);
        }
    };


    render() {

    return (
        <div class="container d-flex align-items-center justify-content-center mt-5" style={{ width: '100%', height: '100%'}}>
            <div>
                <h2>Driver Status Update - Off Duty</h2>
                <form onSubmit={this.handleSubmit}>
                    <div class="form-group">
                        <label for="driverid">Driver Login ID</label>
                        <input type="text" class="form-control" id="driverid" aria-describedby="driveridHelp" placeholder="ex. JT011491" onChange={this.handleInputChange} required/>
                        <small id="driveridHelp" class="form-text text-muted">Format: Driver initials and DOB</small>
                    </div>
                    <div class="form-group">
                        <label for="timestamp">Date/Time of Event</label>
                        <input type="datetime-local" class="form-control" id="timestamp" onChange={this.handleInputChange} required/>
                    </div>
                    <button type="submit" class="btn btn-primary">Submit</button>
                </form>
                <div class="m-5" style={{ color:  this.state.statusStateOK ? 'green' : 'red' } }>{ this.state.statusDetails }</div>
            </div>
        </div>
    );
  }



   

    async sendOffDutyRequest(Driver_Id, timestamp) {

        const body = {
            service: "Duty Status",
            driverId: Driver_Id,
            dutyStatus: "3",
            datetime: timestamp,
            location: "Office",
            remarks: "System Issue - Driver Unable to change duty status."
        }

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        };
        const response = await fetch('driverstatusupdate/setdriverstatus', requestOptions);
        const data = await response.json();
        
        if (data[0].status === "not ok") {
            this.setState({ statusDetails: "ERROR - Confirm DriverID and Date are valid.", statusStateOK: false });
            console.log(data)
        } else {
            this.setState({ statusDetails: "SUCCESS : " + data[0].msg, statusStateOK: true });
        }
    }
}
